import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeaturedLaptop2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_635_1424)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M2.5 7C2.5 3.96243 4.96243 1.5 8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7Z",
			stroke: "#D6D6D6",
			shapeRendering: "crispEdges"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M23.9999 19.6667V13.8C23.9999 13.0533 23.9999 12.6799 23.8546 12.3947C23.7268 12.1438 23.5228 11.9398 23.2719 11.812C22.9867 11.6667 22.6133 11.6667 21.8666 11.6667H14.1333C13.3865 11.6667 13.0131 11.6667 12.7279 11.812C12.477 11.9398 12.2731 12.1438 12.1452 12.3947C11.9999 12.6799 11.9999 13.0533 11.9999 13.8V19.6667M13.111 22.3333H22.8888C23.3021 22.3333 23.5088 22.3333 23.6783 22.2879C24.1385 22.1646 24.4979 21.8052 24.6212 21.3451C24.6666 21.1755 24.6666 20.9689 24.6666 20.5556C24.6666 20.3489 24.6666 20.2456 24.6439 20.1608C24.5822 19.9307 24.4025 19.751 24.1725 19.6894C24.0877 19.6667 23.9844 19.6667 23.7777 19.6667H12.2221C12.0155 19.6667 11.9122 19.6667 11.8274 19.6894C11.5973 19.751 11.4176 19.9307 11.356 20.1608C11.3333 20.2456 11.3333 20.3489 11.3333 20.5556C11.3333 20.9689 11.3333 21.1755 11.3787 21.3451C11.502 21.8052 11.8614 22.1646 12.3215 22.2879C12.491 22.3333 12.6977 22.3333 13.111 22.3333Z",
			stroke: "#424242",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_635_1424",
		x: 0,
		y: 0,
		width: 36,
		height: 36,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_635_1424"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_635_1424",
				result: "shape"
			})
		]
	}) })]
});
export default SvgFeaturedLaptop2;
